<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();
const { field } = useInlineBlockEditor(props.id);

const stateKey = field<string>("stateKey", "assessment.resume");
const fallbackPath = field<string>("fallbackPath", "/");
const delaySeconds = field<number>("delaySeconds", 0);
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:history" accent="navigation">
    <EditorField :label="t('stateKey')" :hint="t('stateKeyHint')">
      <Input
        v-model="stateKey"
        class="h-8 rounded-sm bg-muted font-mono text-[13px]"
        placeholder="assessment.resume"
      />
    </EditorField>

    <EditorField :label="t('fallbackPath')" :hint="t('fallbackPathHint')">
      <EditorPathInput
        v-model="fallbackPath"
        mode="existing-file"
        :scopes="['site', 'external']"
        allow-http-urls
        placeholder="/assessment/start"
        aria-label="Fallback path"
      />
    </EditorField>

    <EditorField :label="t('delay')">
      <Input
        v-model.number="delaySeconds"
        type="number"
        min="0"
        class="h-8 rounded-sm bg-muted text-[13px]"
      />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: User State Redirect
  stateKey: State key
  stateKeyHint: Combined with this block's resolved data path.
  fallbackPath: Fallback path
  fallbackPathHint: Used when the state is missing or invalid. Supports site-local paths and HTTPS URLs.
  delay: Redirect delay (seconds)
</i18n>
